import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M40 4c-1.424 0-2.71.595-3.62 1.55-.065.04-.126.088-.182.143L22.722 18.945a3.002 3.002 0 0 0-.734 1.167l-2.279 6.652a2 2 0 0 0 2.524 2.546l6.623-2.208a3 3 0 0 0 1.198-.75l13.271-13.6a1.01 1.01 0 0 0 .075-.085A5 5 0 0 0 40 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 19a1 1 0 0 0-1 1v5.966c0 3.419-.127 6.818-.382 10.199a7 7 0 0 1-6.454 6.454C29.795 42.873 26.407 43 23 43c-3.41 0-6.8-.127-10.17-.382a7 7 0 0 1-6.453-6.453 136.205 136.205 0 0 1 .007-20.33 7 7 0 0 1 6.453-6.454A135.11 135.11 0 0 1 23 9h6a1 1 0 1 0 0-2h-6c-3.457 0-6.895.129-10.313.387a9 9 0 0 0-8.298 8.298 138.206 138.206 0 0 0-.007 20.63 9 9 0 0 0 8.298 8.298 137.671 137.671 0 0 0 20.634 0 9 9 0 0 0 8.298-8.298c.259-3.43.388-6.88.388-10.35V20a1 1 0 0 0-1-1Z",
    fill: "currentColor"
  }));
};

var SvgNotes = styled(SvgComponent).withConfig({
  displayName: "Notes__SvgNotes",
  componentId: "sc-wsf7yo-0"
})(["", " ", ""], size, color);
export default SvgNotes;